/**
 * Geohash encode + neighbors for nearby driver queries (prefix queries on RTDB /locations).
 * Precision 5 ≈ 4.9 km cells — suitable for ~3–5 km pickup radius.
 */

const BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';

const NEIGHBOR = {
  n: ['p0r21436x8zb9dcf5h7kjnmqesgutwvy', 'bc01fg45238967deuvhjyznpkmstqrwx'],
  s: ['14365h7k9dcfesgujnmqp0r2twvyx8zb', '238967debc01fg45kmstqrwxuvhjyznp'],
  e: ['bc01fg45238967deuvhjyznpkmstqrwx', 'p0r21436x8zb9dcf5h7kjnmqesgutwvy'],
  w: ['238967debc01fg45kmstqrwxuvhjyznp', '14365h7k9dcfesgujnmqp0r2twvyx8zb'],
};

const BORDER = {
  n: ['prxz', 'bcfguvyz'],
  s: ['028b', '0145hjnp'],
  e: ['bcfguvyz', 'prxz'],
  w: ['0145hjnp', '028b'],
};

export function encodeGeohash(latitude, longitude, precision = 5) {
  let latMin = -90;
  let latMax = 90;
  let lonMin = -180;
  let lonMax = 180;
  let hash = '';
  let bit = 0;
  let ch = 0;
  let even = true;

  while (hash.length < precision) {
    if (even) {
      const mid = (lonMin + lonMax) / 2;
      if (longitude >= mid) {
        ch |= 1 << (4 - bit);
        lonMin = mid;
      } else {
        lonMax = mid;
      }
    } else {
      const mid = (latMin + latMax) / 2;
      if (latitude >= mid) {
        ch |= 1 << (4 - bit);
        latMin = mid;
      } else {
        latMax = mid;
      }
    }
    even = !even;
    if (bit < 4) {
      bit++;
    } else {
      hash += BASE32.charAt(ch);
      bit = 0;
      ch = 0;
    }
  }
  return hash;
}

function adjacent(hash, dir) {
  if (!hash || !hash.length) return '';
  const lastCh = hash.slice(-1);
  const parent = hash.slice(0, -1);
  const type = hash.length % 2;
  let next = parent;
  if (BORDER[dir][type].indexOf(lastCh) !== -1 && parent) {
    next = adjacent(parent, dir);
  }
  return next + BASE32.charAt(NEIGHBOR[dir][type].indexOf(lastCh));
}

/** Center cell + 8 neighbors (max 9 unique hashes). */
export function geohashNeighbors(hash) {
  if (!hash) return [];
  const n = adjacent(hash, 'n');
  const s = adjacent(hash, 's');
  const e = adjacent(hash, 'e');
  const w = adjacent(hash, 'w');
  const cells = [
    hash,
    n,
    s,
    e,
    w,
    adjacent(n, 'e'),
    adjacent(n, 'w'),
    adjacent(s, 'e'),
    adjacent(s, 'w'),
  ].filter(Boolean);
  return [...new Set(cells)];
}

export const GEOHASH_PRECISION = 5;
/** Precisión guardada en locations/{uid}: las consultas por prefijo de 4, 5 y 6 caracteres la contienen. */
export const LOCATION_GEOHASH_PRECISION = 7;
export const NEARBY_RADIUS_KM = 5;
export const EXPAND_RADIUS_KM = 15;
export const MIN_NEARBY_DRIVERS = 8;
